module.exports = __webpack_public_path__ + "img/tab-season.e476fac2.png";